module.exports = "/packs/images/homepage/facilities/extreme_desktop~9f33d5ff3f29106e2b6868af591796eb.jpg";